
import DropzoneBase from "@/components/base/input/dropzone/DropzoneBase"
export default {
    components: {
        DropzoneBase,
    },
    emits: ["filesDropped", "imageReady", "image", "imageFailed"],
    props: {
        maxSize: {
            type: Number,
            default: 15e6, // 20MB
        },
        /** Array of accepted image types */
        accept: {
            type: Array,
            default: () => [
                "image/jpeg",
                "image/png",
                "image/svg+xml",
                "image/svg",
                "image/gif",
                "image/heic",
                "image/heif",
                "image/heif",
            ],
        },
    },
    data() {
        return {
            error: "",
            showError: false,
        }
    },
    methods: {
        showErrorSnackbar(message) {
            this.showError = false
            this.$nextTick(() => {
                this.error = message
                this.showError = true
            })
        },
        /** SHOULD BE MIXIN VVV */
        async receiveImages(files) {
            this.$emit("filesDropped", files)
            for (const file of files) {
                this.$emit("image", file)
                this.process(file)
                    .then((img) => {
                        this.$emit("imageReady", img)
                    })
                    .catch((err) => this.$emit("imageFailed", err))
                /** Spread processing load */
                await new Promise((resolve) => setTimeout(resolve, 500))
            }
        },
        async process(file) {
            let img = file
            if (this.validateImage(img)) {
                try {
                    if (img.type === "image/heic" || img.type === "image/heif")
                        img = await this.convertImage(img)
                    // if image is valid, proceed to the cropping step
                    return await this.getBase64(img)
                } catch (e) {
                    console.error(e)
                    this.showErrorSnackbar(
                        `Fehler bei der verarbeitung von Datei: ${img.name}`
                    )
                }
            }
        },
        validateImage(image) {
            if (this.accept.indexOf(image.type) === -1) {
                this.showErrorSnackbar("Ungültiger Dateityp")
                return false
            }
            if (image.size > this.maxSize) {
                this.showErrorSnackbar("Datei zu groß")
                return false
            }
            return true
        },
        async convertImage(image) {
            const heic2any = await import("heic2any")
            return await heic2any.default({ blob: image })
        },
        getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = (error) => reject(error)
            })
        },
        /** SHOULD BE MIXIN ^^^ */
    },
}
